/* eslint-disable react/no-unknown-property */
import React from 'react';
import * as styles from './TeamLeaderboardPositionPreview.style';
import TeamLeaderboardPositionSkeleton from '../team-leaderboard-position/TeamLeaderboardPosition.skeleton';

const TeamLeaderboardPositionPreviewSkeleton: React.FC = () => (
  <div css={styles.rankPreview} $isClickable>
    <TeamLeaderboardPositionSkeleton />
  </div>
);

export default TeamLeaderboardPositionPreviewSkeleton;
